import { render, staticRenderFns } from "./InpuOriginMethods.vue?vue&type=template&id=32f649f7&scoped=true&"
import script from "./InpuOriginMethods.vue?vue&type=script&lang=js&"
export * from "./InpuOriginMethods.vue?vue&type=script&lang=js&"
import style0 from "./InpuOriginMethods.vue?vue&type=style&index=0&id=32f649f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f649f7",
  null
  
)

export default component.exports